import React, { useEffect } from "react";
import { Grid, Typography, Container, ListItemIcon } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { List, ListItem, ListItemText, Box } from "@mui/material";
import HeaderBanner from "../../assets/others/about-us.png";
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import Aboutusimage1 from "../../assets/99giftimages/Aboutus1.svg";
import Aboutusimage2 from "../../assets/99giftimages/Aboutus2.svg";
import WhatweOffer from "../../assets/99giftimages/What We Offer.jpeg";
import WhyweChoose from "../../assets/99giftimages/Why Choose Us.jpeg";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CorparateImage from "../../assets/99giftimages/Corporate.jpeg";
import Compliance from "../../assets/99giftimages/Compliance.jpeg";

const Index = (props) => {
  const { isMobile = false } = props;
  const Mobile = useMediaQuery("(max-width:480px)");
  const backgroundColor = Mobile ? "#fff" : "white.main";
  const giftCardContiner = {
    boxShadow: { xs: 0, sm: 1, md: 2 },
    borderRadius: { xs: 0, sm: 1, md: 3 },
    p: { xs: 0, sm: 2, md: 3 },
    my: { xs: 2, sm: 3, md: 3 },
    backgroundColor: backgroundColor,
  };
  useEffect(()=>{
        window.scrollTo(0, 0);
  },[])

  return (
    <React.Fragment>
      {!isMobile && (
        <Container maxWidth="xl">
          <PageBreadcrumb home="Home" currentProduct="aboutus" />
        </Container>
      )}

      <Container maxWidth="false">
        <Box
          sx={{
            objectFit: "cover",
            minHeight: { sm: "216px" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={HeaderBanner}
            alt="Header Banner"
            style={{
              objectFit: "contain",
              width: "100%",
              height: "auto",
              borderRadius: 10,
            }}
          />
        </Box>
      </Container>

      <Container
        maxWidth="false"
        disableGutters={true}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#F1F5F6",
          "@media (max-width:480px)": {
            backgroundColor: "white.main",
          },
        }}
      >
        <Grid
          container
          alignItems="center"
          maxWidth="lg"
          sx={{
            px: { xs: 2, md: 0 },
            justifyContent: "center",
          }}
        >
          <Grid item xs={12}>
            <WhoweAreAboutus giftCardContiner={giftCardContiner} />

            <WhyweOffer giftCardContiner={giftCardContiner} />
            <WhychoosegiftCard giftCardContiner={giftCardContiner} />
            <CorpPolicyThirdPartyDisclosure
              giftCardContiner={giftCardContiner}
            />
            <CorpPolicyRetention giftCardContiner={giftCardContiner} />
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Index;

function PrivacyPolicyInnerTitle({ param1, param2 }) {
  return (
    <React.Fragment>
      {param1 && (
        <Typography
          variant="h3"
          color="priimary.main"
          sx={{
            display: "inline-block",
            fontSize: { xs: "14.5px", md: "18px" },
            mt: { xs: 2, md: 0 },
            fontFamily: "Be Vietnam Pro",
          }}
        >
          {param1}
        </Typography>
      )}
      {param2 && (
        <Typography
          variant="h3"
          color="secondary.main"
          sx={{
            display: "inline-block",
            ml: { xs: "2px", md: "3px" },
            fontSize: { xs: "14.5px", md: "18px" },
          }}
        >
          {param2}
        </Typography>
      )}
    </React.Fragment>
  );
}

function WhoweAreAboutus() {
  const orders = [
    {
      Content:
        "99gift.ae is a UAE-focused digital gifting platform that enables individuals and businesses to buy digital gift cards online in the UAE with instant delivery and secure payments. Our goal is to simplify gifting by offering a fast, reliable, and flexible online solution designed specifically for the United Arab Emirates.",
    },
    {
      SubContent:
        "We understand the diverse lifestyle and fast-moving environment of the UAE, where convenience, trust, and speed are essential. 99gift was created to meet these expectations.",
    },

    {
      Listcontent: "A UAE-oriented online gift card platform",
    },
    {
      Listcontent:
        "Focused on digital Branded gift cards, e-gift cards, and online gift vouchers",
    },
    {
      Listcontent:
        "Serving customers across Dubai, Abu Dhabi, Sharjah, and all Emirates",
    },
    {
      Listcontent:
        "Built to support personal gifting and corporate gifting needs",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={3} mt={5} mb={5}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: 320,
              height: "auto",
            }}
          >
            {/* Top Image */}
            <Box
              component="img"
              src={Aboutusimage1}
              alt="shopping"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 3,
                position: "relative",
                zIndex: 1,
              }}
            />

            {/* Bottom Overlapping Card */}
            <Box
              component="img"
              src={Aboutusimage2}
              alt="cart"
              sx={{
                width: { xs: 140, md: 230 },
                height: "auto",
                objectFit: "contain",
                borderRadius: 3,
                background: "none",
                position: "absolute",
                bottom: { xs: -30, md: -70 },
                left: { xs: 60, md: 180 },
                zIndex: 2,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <PrivacyPolicyInnerTitle
            param1="About Us |"
            param2=" Branded Gift Cards in the UAE"
          />
          <Box
            sx={{
              mt: 2,
              display: "block",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "16px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
              }}
            >
              {orders[0].Content}
            </Typography>

            <List>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Be Vietnam Pro",
                  fontWeight: 500,
                  mt: 2,
                }}
              >
                Who We Are
              </Typography>
              {orders.map(
                (order, index) =>
                  order?.Listcontent && (
                    <ListItem
                      key={index}
                      dense
                      sx={{ pl: 0, alignItems: "flex-start" }}
                    >
                      <ListItemIcon sx={{ minWidth: "28px", mt: "4px" }}>
                        <ArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: "secondary.main",
                            fontWeight: 600,
                          }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary={order?.Listcontent}
                        primaryTypographyProps={{
                          fontSize: { xs: "13.5px", md: "14px" },
                          color: "primary.main",
                          fontFamily: "Be Vietnam Pro",
                          fontWeight: { xs: 400, md: 300 },
                        }}
                      />
                    </ListItem>
                  ),
              )}
            </List>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "14px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
                mt: 1,
              }}
            >
              {orders[1].SubContent}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function WhyweOffer() {
  const orders = [
    {
      content: "At 99gift, we provide:",
    },
    {
      subcontent:
        "Our platform removes the uncertainty of traditional gifting by allowing recipients to choose what suits them best.",
    },
    {
      Listcontent: "Digital gift cards delivered instantly by email",
    },
    {
      Listcontent: "Secure online payments with trusted payment gateways",
    },
    {
      Listcontent: "AED-based pricing for transparency",
    },
    {
      Listcontent:
        "Gift cards suitable for shopping, dining, entertainment, lifestyle, and more",
    },
    {
      Listcontent: "Clear terms, validity details, and redemption instructions",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={3} mt={5} mb={5}>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          sx={{
             order:{xs:2, sm:1}
          }}
        >
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 500,
                mt: 2,
              }}
            >
              What We Offer
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "15px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
                mt: 2,
              }}
            >
              {orders[0].content}
            </Typography>
            <List>
              {orders.map(
                (order, index) =>
                  order?.Listcontent && (
                    <ListItem
                      key={index}
                      dense
                      sx={{ pl: 0, alignItems: "flex-start" }}
                    >
                      <ListItemIcon sx={{ minWidth: "28px", mt: "4px" }}>
                        <ArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: "secondary.main",
                            fontWeight: 600,
                          }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary={order?.Listcontent}
                        primaryTypographyProps={{
                          fontSize: { xs: "13.5px", md: "14px" },
                          color: "primary.main",
                          fontFamily: "Be Vietnam Pro",
                          fontWeight: { xs: 400, md: 300 },
                        }}
                      />
                    </ListItem>
                  ),
              )}
            </List>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "14px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
                mt: 2,
              }}
            >
              {orders[1].subcontent}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}
           sx={{
            order:{xs:1 , sm:2}
           }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 550,
              height: "auto",
            }}
          >
            {/* Bottom Overlapping Card */}
            <Box
              component="img"
              src={WhatweOffer}
              alt="cart"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 3,
                background: "none",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function WhychoosegiftCard() {
  const orders = [
    {
      subcontent:
        "Our business gifting solutions are designed to be professional, scalable, and easy to manage.",
    },
    {
      Listcontent: "Instant delivery across the UAE",
    },
    {
      Listcontent: "Secure and encrypted transactions",
    },
    {
      Listcontent: "User-friendly online experience",
    },
    {
      Listcontent: "No physical cards or shipping delays",
    },
    {
      Listcontent: "Trusted digital gifting solution for UAE customers",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={3} mt={5} mb={5}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box
            sx={{
              width: "100%",
              maxWidth: 550,
              height: "auto",
            }}
          >
            {/* Bottom Overlapping Card */}
            <Box
              component="img"
              src={WhyweChoose}
              alt="cart"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 3,
                background: "none",
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 600,
                mb: 2,
              }}
            >
              Why Choose 99gift:
            </Typography>
            <List>
              {orders.map(
                (order, index) =>
                  order?.Listcontent && (
                    <ListItem
                      key={index}
                      dense
                      sx={{ pl: 0, alignItems: "flex-start" }}
                    >
                      <ListItemIcon sx={{ minWidth: "28px", mt: "4px" }}>
                        <ArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: "secondary.main",
                            fontWeight: 600,
                          }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary={order?.Listcontent}
                        primaryTypographyProps={{
                          fontSize: { xs: "13.5px", md: "14px" },
                          color: "primary.main",
                          fontFamily: "Be Vietnam Pro",
                          fontWeight: { xs: 400, md: 300 },
                        }}
                      />
                    </ListItem>
                  ),
              )}
            </List>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "14px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
                mt: 2,
              }}
            >
              {orders[0].subcontent}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function CorpPolicyThirdPartyDisclosure() {
  const orders = [
    {
      content:
        "99gift.ae also supports corporate gift cards in the UAE, helping businesses:",
    },
    {
      subcontent:
        "Our business gifting solutions are designed to be professional, scalable, and easy to manage.",
    },
    {
      Listcontent: "Reward and motivate employees",
    },
    {
      Listcontent: "Appreciate clients and partners",
    },
    {
      Listcontent:
        "Manage festive gifting such as Ramadan, Eid, and year-end rewards",
    },
    {
      Listcontent: "Purchase gift cards in bulk efficiently",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={3} mt={5} mb={5}>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          sx={{
            order: { xs: 2, sm: 1 },
          }}
        >
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 600,
                mb: 2,
              }}
            >
              Corporate & Business Gifting Solutions
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "16px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
              }}
            >
              {orders[0].content}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 400,
                mt: 1,
              }}
            >
              {orders[1].content}
            </Typography>
            <List>
              {orders.map(
                (order, index) =>
                  order?.Listcontent && (
                    <ListItem
                      key={index}
                      dense
                      sx={{ pl: 0, alignItems: "flex-start" }}
                    >
                      <ListItemIcon sx={{ minWidth: "28px", mt: "4px" }}>
                        <ArrowRightIcon
                          sx={{
                            fontSize: 18,
                            color: "secondary.main",
                            fontWeight: 600,
                          }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        primary={order?.Listcontent}
                        primaryTypographyProps={{
                          fontSize: { xs: "13.5px", md: "14px" },
                          color: "primary.main",
                          fontFamily: "Be Vietnam Pro",
                          fontWeight: { xs: 400, md: 300 },
                        }}
                      />
                    </ListItem>
                  ),
              )}
            </List>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "14px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
                mt: 2,
              }}
            >
              {orders[1].subcontent}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          sx={{
            order: { xs: 1, sm: 2 },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 550,
              height: "auto",
            }}
          >
            {/* Bottom Overlapping Card */}
            <Box
              component="img"
              src={CorparateImage}
              alt="cart"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 3,
                background: "none",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

function CorpPolicyRetention() {
  const orders = [
    {
      content:
        "We operate in line with UAE e-commerce and consumer protection standards. Customer data is handled responsibly, and sensitive payment information is protected using secure systems. We provide transparent information so customers can make informed decisions.",
    },
    {
      content:
        "Our mission is to become a trusted digital gift card platform in the UAE by offering secure, convenient, and customer-centric gifting solutions that meet modern gifting needs.",
    },
  ];
  return (
    <React.Fragment>
      <Grid container spacing={3} mt={5} mb={5}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box
            sx={{
              width: "100%",
              maxWidth: 550,
              height: "auto",
            }}
          >
            {/* Bottom Overlapping Card */}
            <Box
              component="img"
              src={Compliance}
              alt="cart"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 3,
                background: "none",
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 600,
                mb: 2,
              }}
            >
              Compliance, Security & Transparency
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: { xs: "13.5px", md: "16px" },
                color: "dark.main",
                fontWeight: { xs: 400, md: 400 },
                fontFamily: "Be vietnam Pro",
              }}
            >
              {orders[0].content}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Be Vietnam Pro",
                fontWeight: 600,
                mb: 2,
                mt: 2,
              }}
            >
              Our Mission
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "13.5px", md: "16px" },
                fontFamily: "Be Vietnam Pro",
                fontWeight: 400,
                mt: 1,
              }}
            >
              {orders[1].content}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
